Last Modified: 2024/05/03 10:40:29
This is a drop down widget that can be specified in the interface definition to
show up on the input page. Its input persists in storage with the prediction but
it is not used in the calculation of the prediction.

This widget is NOT to be used for drop down selection for inputs that affect the
prediction.

This widget still needs a separate & unique id.

<template>
    <div class="widget-item">
        <div class="input-item-body">
            <p v-if="widget.description">{{ widget.description }}</p>

            <div class="state-list mb-1">
                <!-- the only difference between this and a regular widget is here VVV -->
                <!-- rather than using the states via a variable we use hardcoded states specified in the widget definition -->
                <div class="state-item" v-for="(state, index) in labels" :key="index"
                    :class="[{ active: state === activeState }, `state-item-${mode}`]" @click="toggleState(state)">
                    {{ labels[index] }}
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'DropDownNonBNInputWidget',
    props: {
        mode: String,
        widget: Object
    },
    computed: {

        variable() {
            try {
                //console.log(this.widget)
                return this.widget.id
            } catch {
                return this.widget.id
            }
        },
        activeState() {
            return this.$store.getters['getInputById'](this.widget.id)
        },
        saveAvailable: {
            get() {
                return this.$store.state.intf.saveAvailable
            },
            set(value) {
                this.$store.commit('setSaveAvailable', value)
            }
        },
        labels() {
            return (this.widget.parameters && this.widget.parameters.alt_states) ? this.widget.parameters.alt_states : this.widget.parameters.states
        }
    },
    methods: {
        toggleState(stateName) {

            if (this.saveAvailable == true) {
                this.saveAvailable = false
            }

            this.$store.dispatch('changeState', {
                widgetIdentifier: this.widget.id,
                stateName: stateName
            })
        }
    }
}
</script>

<style scoped>
.input-container {
    flex-flow: column;
    flex-grow: 0;
    overflow-y: auto;
}

.info-btn {
    cursor: pointer;
}

.info-icon {
    width: 18px;
    height: 18px;
    fill: var(--light);
    margin: 5px 2px 8px 5px;
}

.state-item {
    text-align: center;
    border-bottom: 1px solid rgb(248, 248, 248);
    padding: 10px 0px;
    background-color: rgb(221, 221, 221);
    transform: scale(1);
    transition: background-color 0.1s ease-in, transform 0.1s ease-out;
}

.state-item-update {
    cursor: pointer;
}

.state-item-view {
    pointer-events: none;
}

.state-item:hover {
    background-color: rgb(207, 207, 207);
}

.state-item.active {
    background-color: #81c4ee;
}

.state-item.active:hover {
    background-color: #78b1d4;
}

.state-item:active {
    transform: scale(0.97);
}
</style>